import React from 'react';

interface DataClassificationBadgeProps {
  classification: 'C1' | 'C2' | 'C3' | 'C4';
  className?: string;
}

const CLASSIFICATION_CONFIG: Record<string, { label: string; colorClass: string; ariaLabel: string }> = {
  C1: {
    label: 'Données Publiques · Cloud OK',
    colorClass: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    ariaLabel: 'Niveau de données : C1 - Publique',
  },
  C2: {
    label: 'Données Internes · Cloud OK',
    colorClass: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    ariaLabel: 'Niveau de données : C2 - Interne',
  },
  C3: {
    label: 'Données Sensibles · On-Prem Uniquement',
    colorClass: 'bg-orange-500/10 text-orange-500 border-orange-500/20',
    ariaLabel: 'Niveau de données : C3 - Sensible',
  },
  C4: {
    label: 'Données Confidentielles · Local Uniquement',
    colorClass: 'bg-red-500/10 text-red-500 border-red-500/20',
    ariaLabel: 'Niveau de données : C4 - Confidentielle',
  },
};

export function DataClassificationBadge({ classification, className = '' }: DataClassificationBadgeProps) {
  const config = CLASSIFICATION_CONFIG[classification] || CLASSIFICATION_CONFIG['C1'];

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[9px] font-medium border ${config.colorClass} ${className}`}
      role="status"
      aria-label={config.ariaLabel}
      title={config.label}
    >
      {classification}
    </span>
  );
}
